import { SET_LAYERS, CLEAR_LAYERS, } from "../actions/layerActions";

const initialState = {
  layers: [],
}

function layerReducer(state = initialState, action) {
  switch (action.type) {
  case SET_LAYERS:
    return {
      ...state,
      layers: action.payload
    }
  case CLEAR_LAYERS:
    return {
      ...state,
      layers: []
    }
  default:
    return state;
  }
}

export default layerReducer;